import React, { useState, useEffect } from 'react';
import { getApi } from '../../api/endpoints.js';
import {useParams, useNavigate} from 'react-router-dom'
import Coordinator from '../../models/Coordinator.js'
import { toast } from 'react-toastify';
import FormPartial from './FormPartial.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";

const Edit = () => {
  const navigate = useNavigate();
  const params = useParams();
  let coordinatorObj = new Coordinator({service_center_id: params.service_center_id});
  const [coordinator, setCoordinator] = useState(coordinatorObj.toStateJson());
  const [updateApi] = getApi('updateCoordinator');
  const [showApi] = getApi('showCoordinator');

  useEffect(() => {
    setCoordinatorObj();
  }, [])

  const setCoordinatorObj = async () => {
    try {
      const response = await showApi({id: params.id}).unwrap();
      setCoordinator(new Coordinator(response?.data?.dsc_coordinator).toStateJson());
    } catch (error) {
      toast.error(error?.data?.message || "something went wrong")
    }
  }

  const udpateRecord = async (parameters) => {
    try {
      await updateApi(parameters).unwrap();
      toast.success("Coordinator updated Successfully")
      navigate( `/service_centers/${params.service_center_id}`)
    } catch (error) {
      toast.error(error.data?.message)
      coordinatorObj.set_api_errors(error.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      udpateRecord((new Coordinator(coordinator)).toApiJson());
    } catch(error){
      setCoordinator(new Coordinator(coordinator));
    }
  }

  const handleCancelFunction = () => {
    navigate(`/service_centers/${params.service_center_id}`);
  }

  return <PageContentWrapper contentHeading={"Update Coordinator"}>
    <div className='m-3'>
      <div className='mb-4 col-md-12'>
        <form className="row g-3" autoComplete="off">
          <FormPartial coordinator={coordinator} setCoordinator={setCoordinator} />
          <div className='mb-4 col-md-12'>
            <div >
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Update Coordinator</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </PageContentWrapper>
};

export default Edit;
